// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/search/v1/legacy_portal_service.proto (package spwn.search.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { GetEventSearchConditionsRequest, GetEventSearchConditionsResponse, LegacyPortalSearchServiceSearchEventRequest, LegacyPortalSearchServiceSearchEventResponse, LegacyPortalSearchServiceSearchGoodsRequest, LegacyPortalSearchServiceSearchGoodsResponse } from "./legacy_portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.search.v1.LegacyPortalSearchService
 */
export const LegacyPortalSearchService = {
    typeName: "spwn.search.v1.LegacyPortalSearchService",
    methods: {
        /**
         * イベント一覧の検索
         *
         * @generated from rpc spwn.search.v1.LegacyPortalSearchService.SearchEvent
         */
        searchEvent: {
            name: "SearchEvent",
            I: LegacyPortalSearchServiceSearchEventRequest,
            O: LegacyPortalSearchServiceSearchEventResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * グッズ一覧の検索
         *
         * @generated from rpc spwn.search.v1.LegacyPortalSearchService.SearchGoods
         */
        searchGoods: {
            name: "SearchGoods",
            I: LegacyPortalSearchServiceSearchGoodsRequest,
            O: LegacyPortalSearchServiceSearchGoodsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * イベント詳細検索用の条件取得
         *
         * @generated from rpc spwn.search.v1.LegacyPortalSearchService.GetEventSearchConditions
         */
        getEventSearchConditions: {
            name: "GetEventSearchConditions",
            I: GetEventSearchConditionsRequest,
            O: GetEventSearchConditionsResponse,
            kind: MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map